import { ArrowUpRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useRankingParticipantCopy } from '@/i18n/rankingParticipant';
import type { CampaignRanking } from '@/queries/cpmRanking';

export function RankingAdvanceProgress({ progress }: { progress: NonNullable<CampaignRanking['my_progress']> }) {
  const { i18n } = useTranslation();
  const copy = useRankingParticipantCopy();
  const locale = i18n?.resolvedLanguage || i18n?.language;
  const format = (value: string) => BigInt(value).toLocaleString(locale);
  const target = progress.target_type;
  if (!['qualification', 'next_position', 'leader', 'tie_review'].includes(target)) return null;

  return <div data-testid="ranking-advance-progress" className="space-y-2 rounded-lg border border-primary/20 bg-background/50 p-4">
    <h3 className="flex items-center gap-2 font-semibold"><ArrowUpRight aria-hidden="true" className="h-4 w-4 text-primary" />{copy.progressTitle}</h3>
    {target === 'leader' ? <p className="text-sm">{copy.leader}</p>
      : target === 'tie_review' ? <p className="text-sm">{copy.tieReview}</p>
        : <>
          <p className="text-sm font-medium">{target === 'qualification' ? copy.qualificationTarget : progress.next_position != null ? copy.nextPositionTarget(progress.next_position.toLocaleString(locale)) : copy.progressTitle}</p>
          {progress.views_needed != null && <p className="text-sm text-muted-foreground">{copy.viewsNeeded(format(progress.views_needed))}</p>}
          {progress.estimated_clips_needed != null ? <>
            <p data-testid="ranking-clips-estimate" className="text-base font-semibold text-primary">{copy.clipEstimate(format(progress.estimated_clips_needed))}</p>
            <p className="text-xs text-muted-foreground">{copy.estimateHelp}</p>
          </> : <p className="text-xs text-muted-foreground">{copy.estimateUnavailable}</p>}
        </>}
  </div>;
}
